import configData from '../../../config';
import {
    getV2ProgramHeroUrl,
    resolveElearningImagePair,
} from './elearningImagesV2';

export { getV2ProgramHeroUrl, resolveElearningImagePair };

/** Shared program definitions for Dashboard V2 e-learning workspace. */
export const PROGRAM_IDS = {
    BREAKTHROUGH: 'breakthrough',
    PATH: 'path',
    ADDITIONAL: 'additional',
};

export const PROGRAM_CONFIG = {
    [PROGRAM_IDS.BREAKTHROUGH]: {
        id: PROGRAM_IDS.BREAKTHROUGH,
        stripTitle: 'My Breakthrough',
        title: 'My Breakthrough Experience',
        phaseLabel: 'PHASE 2',
        phaseCopy: 'A new module unlocks every 7 days for 12 weeks.',
        modulesKey: 'myBreakthroughExperience',
        level: 1,
        quizPath: '/assessment?AssessmentType=1',
        quizCta: 'Create Your Custom Program',
        stepsGateCopy:
            'Complete Design My Life Blueprint before you start My Breakthrough.',
        stepsPath: '/steps',
        emptyImage:
            'https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=1400&h=900&q=80',
        isAdditional: false,
        listModules: (userId) =>
            `Elearning/GetELearningModules/${userId}/1`,
        detailModule: (moduleId) =>
            `elearning/GetELearningModuleDetail/${moduleId}`,
        completeModule: 'Elearning/CompleteELearningModule',
        saveCustomize: 'ELearning/SaveCustomizeModuleAssessment',
    },
    [PROGRAM_IDS.PATH]: {
        id: PROGRAM_IDS.PATH,
        stripTitle: 'My Path',
        title: 'My Personalized Path',
        phaseLabel: 'PHASE 3',
        phaseCopy: 'A new module unlocks every 30 days for 9 months.',
        modulesKey: 'myPersonalizedPath',
        breakthroughKey: 'myBreakthroughExperience',
        level: 1,
        quizPath: '/assessmentMyPP?AssessmentType=2',
        quizCta: 'Start Your Path!',
        requiresBreakthroughUnlocked: 12,
        gateCopy:
            'Complete all My Breakthrough Experience modules before you start My Path.',
        emptyImage:
            'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&w=1400&h=900&q=80',
        isAdditional: false,
        listModules: (userId) =>
            `Elearning/GetELearningModules/${userId}/1`,
        detailModule: (moduleId) =>
            `elearning/GetELearningModuleDetail/${moduleId}`,
        completeModule: 'Elearning/CompleteELearningModule',
        saveCustomize: 'ELearning/SaveCustomizeModuleAssessment',
    },
    [PROGRAM_IDS.ADDITIONAL]: {
        id: PROGRAM_IDS.ADDITIONAL,
        stripTitle: 'Additional Programs',
        title: 'Additional Programs',
        phaseLabel: 'EXPLORE',
        phaseCopy: 'Continue with purchased programs and certifications.',
        isAdditional: true,
        emptyImage:
            'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?auto=format&fit=crop&w=1400&h=900&q=80',
        listCourses: 'AdditionalCourse/GetCourses',
        listModules: (courseId) =>
            `AdditionalCourse/GetELearningModules/${courseId}`,
        detailModule: (moduleId) =>
            `AdditionalCourse/GetELearningModuleDetail/${moduleId}`,
        completeModule: 'AdditionalCourse/CompleteELearningModule',
        quizPath: (courseId) => `AssesmentNewModules?courseId=${courseId}`,
        quizCta: 'Get Started',
    },
};

export function imgUrl(path) {
    if (!path) return '';
    if (/^https?:\/\//i.test(path)) return path;
    const base = configData.SERVER_URL_IMG || '';
    return `${base}${path}`.replace(/([^:]\/)\/+/g, '$1');
}

export function mediaUrl(path) {
    if (!path) return '';
    if (String(path).search('http') !== -1) return path;
    return imgUrl(path);
}

export function calcProgress(modules = []) {
    if (!modules.length) return 0;
    const done = modules.filter((m) => m.isCompleted).length;
    return Math.round((done / modules.length) * 100);
}

/** V2 hero with Unsplash/legacy fallback when V2 file not uploaded yet */
export function programHeroUrl(programId) {
    const cfg = PROGRAM_CONFIG[programId];
    if (!cfg) return '';
    const v2 = getV2ProgramHeroUrl(programId);
    return v2 || cfg.emptyImage || '';
}

export function programHeroPair(programId) {
    const cfg = PROGRAM_CONFIG[programId];
    const fallback = cfg?.emptyImage || '';
    const v2 = getV2ProgramHeroUrl(programId);
    return {
        src: v2 || fallback,
        fallbackSrc: fallback,
    };
}
